import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    CircularProgress, Tooltip
} from "@mui/material";

import { Download } from '@mui/icons-material';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange } from 'react-date-range';
import axios from 'axios';
import {getAPIEndpointUrl, getToken} from "../../../utilities/ServerRequestModifier";
import {PRIMARY_COLOR} from "../../../constants/Colors";

export default function DownloadBrochuresDialog() {
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);

    const handleClose = () => {
        if (!loading) setOpen(false);
    };

    const handleDownload = async () => {
        try {
            setLoading(true);
            const { startDate, endDate } = state[0];

            // 1. Make the request with responseType 'blob'
            const response = await axios.get(getAPIEndpointUrl() + "/api/admin/export-brochure-requests", {
                params: {
                    token: getToken(),
                    startDate: startDate.toISOString(),
                    endDate: endDate.toISOString(),
                },
                responseType: 'blob', // CRITICAL for binary files
            });

            // 2. Create a URL for the blob
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // 3. Create a temporary anchor element to trigger download
            const link = document.createElement('a');
            link.href = url;

            // Set the filename
            const fileName = `Brochure_Requests_${startDate.toLocaleDateString()}.xlsx`;
            link.setAttribute('download', fileName);

            // 4. Append to body, click, and cleanup
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            handleClose();
        } catch (error) {
            console.error("Download failed:", error);
            alert("Failed to generate Excel file. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Tooltip title={'Download Requests'}>
                <IconButton onClick={() => setOpen(true)} variant={'contained'} style={{backgroundColor: PRIMARY_COLOR, color: '#fff', marginLeft: 20}} size={'small'}>
                    <Download />
                </IconButton>
            </Tooltip>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth={false}
                PaperProps={{
                    style: { width: "auto" }
                }}
            >
                <DialogTitle>Select Date Range</DialogTitle>

                <DialogContent>
                    <DateRange
                        editableDateInputs={true}
                        onChange={item => setState([item.selection])}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                    />
                </DialogContent>

                <DialogActions style={{ padding: '0px 20px 20px 20px' }}>
                    <Button
                        variant="contained"
                        onClick={handleDownload}
                        style={{ color: '#fff' }}
                        fullWidth
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                        {loading ? "Generating..." : "Download Excel"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}